export const redColor = '#E00000';
export const greyColor = '#F7F7F7';